/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-06-18 18:38:21
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-06-23 10:49:02
 * @FilePath: /roboneo-web/src/store/useAIEditImageStore.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { HistoryPlugins } from '@meitu/whee-infinite-canvas';
import { TaskCategory } from '$/api/server.types';

export type EditImageMode = 'modify' | 'extend' | 'eraser' | 'modify_text' | 'screenshot' | 'fusion';

interface AIEditImageState {
  editImageMode: EditImageMode | null;
  editHistoryPlugin: HistoryPlugins | null;
  editImagePrice: Record<TaskCategory, number>;
}

const aiEditImageSlice: StateCreator<AIEditImageState, [
  ['zustand/immer', never],
]> = () => ({
  editImageMode: null,
  editHistoryPlugin: null,
  editImagePrice: {} as Record<TaskCategory, number>,
});

// @ts-ignore
const useAIEditImageStore: UseBoundStore<StoreApi<AIEditImageState>> = create<AIEditImageState>()(immer(aiEditImageSlice));
export default useAIEditImageStore;

/**
 * 设置编辑模式
 * @export
 * @param {EditImageMode} mode
 */
export function setEditImageMode(mode: EditImageMode | null) {
  useAIEditImageStore.setState(() => ({
    editImageMode: mode,
  }));
}

/**
 * 设置编辑历史插件
 *
 * @export
 * @param {HistoryPlugins} plugin
 */
export function setEditHistoryPugin(plugin: HistoryPlugins | null) {
  useAIEditImageStore.setState(() => ({
    editHistoryPlugin: plugin,
  }));
}

/**
 * 设置编辑价格
 *
 * @export
 * @param {Record<TaskCategory, number>} priceObj
 */
export function setEditImagePrice(priceObj: Record<TaskCategory, number>) {
  useAIEditImageStore.setState(() => ({
    editImagePrice: priceObj,
  }));
}
